export default __webpack_public_path__ + "icons/infoCircle-859b53.svg";